$(function() {
    $('.ll-megamenu__toggle-it').on('click', function(e) {
        e.preventDefault()

        var target = $(this).attr('href')

        $(this).siblings().removeClass('is-active')
        $(this).addClass('is-active')
        $('.ll-megamenu__tabtarget').removeClass('is-active')
        $(target).addClass('is-active')
    })
});
